// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    root:         ROOTS.DASHBOARD,
    overview:     ROOTS.DASHBOARD,
    classes:      `${ROOTS.DASHBOARD}/classes`,
    session:      `${ROOTS.DASHBOARD}/session`,
    pastSessions: `${ROOTS.DASHBOARD}/past-sessions`,
  },
};
